import { FLOW_QUERY_KEYS } from 'utils/constants/flow.constant';
import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchFlowNodeRunDetails = ({
  crId, runId, nodeId, enabled = true,
}) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const isEnabled = !!(enabled && crId && runId && nodeId);

  const {
    isLoading, isError, isSuccess, data, refetch, isRefetching,
  } = useQuery(
    [FLOW_QUERY_KEYS.FLOW_NODE_RUN, orgId, crId, runId, nodeId],
    async () => axiosInstance.get(flow(orgId).flowNodeRunDetails(crId, runId, nodeId)),
    {
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || 'Failed to fetch flow node run details';
        dispatch(showAlert({ message: errorMessage, type: 'error' }));
      },
      select: (response) => response?.data,
      refetchOnWindowFocus: false,
      enabled: isEnabled,
    },
  );

  return {
    isLoading,
    isError,
    isSuccess,
    data,
    refetch,
    isRefetching,
  };
};

